/**
 * เลือกชื่อให้ตรงกับภาษาที่ใช้งานอยู่ — ใช้กับ entity ที่มี name (EN) + nameTh คู่กัน
 * (Category, SubCategory, Location, Brand, Model, Vendor ทั้งหมดมี field คู่นี้เหมือนกัน)
 *
 * ตกกลับไปใช้ name (EN) เสมอถ้า nameTh ว่าง — กันกรณีข้อมูลเก่าที่ยังไม่เคยกรอกชื่อไทยไว้
 */
export function localizedName(
  item: { name?: string | null; nameTh?: string | null; code?: string } | null | undefined,
  language: string,
): string {
  if (!item) return ''
  if (language === 'th' && item.nameTh) return item.nameTh
  return item.name ?? item.code ?? ''
}

/**
 * เหมือน localizedName() แต่ตอนภาษาไทย จะโชว์ "ชื่อไทย (English Name)" ต่อท้ายวงเล็บด้วย
 * ใช้กับ Brand ตามที่ขอ — ช่วยให้เห็นชื่ออังกฤษกำกับไว้เผื่อสับสน และเป็นผลพลอยได้ที่ Mantine
 * Select ค้นหาจาก label ทั้งก้อน ทำให้ค้นหาได้ทั้ง 2 ภาษาในตัวโดยไม่ต้องแก้ logic การค้นหาแยก
 */
export function localizedNameWithEn(
  item: { name?: string | null; nameTh?: string | null; code?: string } | null | undefined,
  language: string,
): string {
  if (!item) return ''
  if (language === 'th' && item.nameTh) {
    return item.name && item.name !== item.nameTh ? `${item.nameTh} (${item.name})` : item.nameTh
  }
  return item.name ?? item.code ?? ''
}
